import "sweetalert";
import { announceNewActionSuccess } from "#/admin/legacy/forms/new-action-modal-success.js";
import "#legacy/shared/components/wizard_modal.js";
import "#legacy/admin/form.js";

jQuery(function () {
  var inProgress = false;
  var modal;

  // BEHAVIOUR

  jQuery(document).on("click", '[data-behaviour~="new-action-json-modal"]', function (event) {
    event.preventDefault();
    loadRemoteModal(this, { format: "json" });
  });
  jQuery(document).on("click", '[data-behaviour~="new-action-js-modal"]', function (event) {
    event.preventDefault();
    loadRemoteModal(this);
  });
  jQuery(document).on("click", '[data-behaviour~="new-action-modal"]', function (event) {
    event.preventDefault();
    loadHtmlModal(this);
  });

  // HELPER FUNCTIONS

  function loadRemoteModal(trigger, options) {
    if (inProgress) {
      return;
    }

    var formSubmit = loadForm(trigger, jQuery.extend({ remote: true }, options));
    formSubmit.done(function (response) {
      announceNewActionSuccess(trigger, response);
    });

    formSubmit.fail(handleFormSubmitError);
  }

  function loadHtmlModal(trigger) {
    if (inProgress) {
      return;
    }

    var formSubmit = loadForm(trigger);
    formSubmit.fail(handleFormSubmitError);
  }

  function loadForm(trigger, options) {
    var formSubmit = jQuery.Deferred();
    var $trigger = jQuery(trigger);
    var newActionUrl = $trigger.data("url") || $trigger.attr("href") || $trigger.find("[href]").attr("href");
    var stubContext = jQuery(trigger).data("stub-context") || "new",
      options = jQuery.extend(
        {
          title: jQuery(trigger).data("title") || "Quick Add",
          completeText: jQuery(trigger).data("complete-text") || "Done",
          cancelText: jQuery(trigger).data("cancel-text") || "Cancel",
          target: jQuery(trigger).data("modal-target"),
          class: jQuery(trigger).data("modal-modifier-class"),
          escOut: jQuery(trigger).data("modal-modifier-esc-out") !== false,
        },
        options,
      );

    inProgress = true;

    var formLoad = jQuery.get(newActionUrl, { new_action_modal: true });
    formLoad.always(function () {
      inProgress = false;
    });
    formLoad.fail(function (response) {
      swal("Error", response.statusText, "error");
    });
    formLoad.done(function (response) {
      var html = jQuery(response);
      var form = jQuery("<div>").html(html).find("form");

      executeScripts(html);

      // Notify handlers of form submission status
      form.one("ajax:success", function (event, response) {
        formSubmit.resolve(response);
      });
      form.one("ajax:error", function (event, transport) {
        formSubmit.reject(errorResponse(transport));
      });
      form.one("ajax:complete", function (event) {
        form.off(); // turn off event handlers and prevent memory leaks
      });

      createModal(form, formSubmit, stubContext, options);

      $trigger.trigger("new-action-modal:data-loaded");
    });

    return formSubmit;
  }

  // Execute any script tags by momentarily attaching the response to the DOM
  function executeScripts(html) {
    html.appendTo("body").detach();
  }

  function createModal(form, formSubmit, stubContext, options) {
    modal = new WizardModal({
      completeText: options.completeText,
      cancelText: options.cancelText,
      class: options.class,
      escOut: options.escOut,
    });
    modal.addPage({ header: options.title, body: form });

    showOnlyStubFields(form, stubContext);
    window.Form.decorate(form);
    form.attr("novalidate", true); // Don't complain if we've hidden fields that are required
    modal.show();

    // Submit the form when the user completes the wizard
    jQuery(modal).on("beforeComplete", function () {
      if (!submitForm(form, formSubmit, options)) {
        modal.abortCompletion();
      }
    });

    jQuery(modal.container).on("hide", function () {
      modal.destroy();
    });
  }

  function showOnlyStubFields(form, stubContext) {
    var stubFields = form.find("[data-stub-context~=" + stubContext + "]");
    var stubAncestors = stubFields.parentsUntil(form);
    var stubs = stubAncestors.add(stubFields);

    // If stub form fields are present, hide other fields
    stubs.siblings().not(stubs).hide();
  }

  function submitForm(form, formSubmit, options) {
    options = jQuery.extend({}, options);

    if (options.target !== undefined) {
      form.attr("target", options.target);
    }

    if (options.format !== undefined) {
      jQuery('<input type="hidden" name="format" />').val(options.format).appendTo(form);
    }

    if (options.remote !== undefined) {
      form.attr("data-remote", true);
    }

    form.trigger("submit");

    // Notify handlers of form submission status
    form.one("ajax:success", function (event, response) {
      formSubmit.resolve(response);
    });
    form.one("ajax:error", function (event, transport) {
      formSubmit.reject(errorResponse(transport));
    });
    form.one("ajax:complete", function (event) {
      form.off(); // turn off event handlers and prevent memory leaks
    });

    // must detach after submit. Before submit cancels the form submission
    form.detach(); // detach to keep event handlers on form after the modal is destroyed

    return true;
  }

  function errorResponse(transport) {
    return transport.responseJSON || transport;
  }

  function executeJavascriptResponse(response) {
    if (!response || !response.responseText || !isJavascriptResponse(response)) {
      return false;
    }

    jQuery.globalEval(response.responseText);
    return true;
  }

  function isJavascriptResponse(response) {
    if (!response.getResponseHeader) {
      return false;
    }

    var contentType = response.getResponseHeader("Content-Type") || "";
    return contentType.indexOf("javascript") !== -1 || contentType.indexOf("ecmascript") !== -1;
  }

  function handleFormSubmitError(response) {
    if (executeJavascriptResponse(response)) {
      return;
    }

    showError(response);
  }

  function showError(response) {
    var fullMessages = errorMessages(response);
    var fallbackMessage = response && response.statusText ? response.statusText : "Unable to save.";
    swal("Error", fullMessages.join("<br/>") || fallbackMessage, "error");
  }

  function errorMessages(response) {
    if (!response || !response.errors) {
      return [];
    }

    return jQuery.map(response.errors, function (values, key) {
      return key + " " + [].concat(values).join(", ");
    });
  }
});
